import { Link } from "react-router-dom";
import EventbriteModal from "./eventbriteModal";


export default function MyOfferings() {


    return (
        <>
        <div className="bg-neutral-50 pb-5">
<div className="md:flex h-auto items-center justify-center hidden md:block pt-5 ">

    <div className="md:w-1/2 m-5 flex flex-col lg:justify-end">
        <div className="md:text-end mb-10">
            <h1 className="text-4xl md:text-2xl mb-2 ">Nature Flow - San Diego</h1>
            <p className="mb-5 ">Unroll your mat and connect with the earth. Every Sunday at 10 AM we come together to move and breathe,
                finding harmony with our natural surroundings.
                All experience levels are welcome.
            </p>
            <p className="font-bold">📍 Balboa Park - Upas Street & 7th Avenue</p>
            <p className="mb-5 font-bold">Sundays, 10AM</p>
            <button
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
      >
        <Link to="https://sinainfluxyoga.setmore.com/classes/ea9e0268-6e6c-402a-93b4-964b6324c365">Sign Up Here</Link>

      </button>
            {/* <EventbriteModal /> */}
            {/* <button>
                <Link
                    to="https://www.eventbrite.com/e/morning-vinyasa-flow-in-balboa-park-nature-flow-tickets-1375070566079?aff=oddtdtcreator"
                    className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
                >
                    Sign Up Here
                </Link>
            </button> */}
        </div>
        {/* <div className="md:text-end p-4 border">
            <h1 className="text-4xl md:text-2xl mb-2">Vinyasa Flow at Mind Body Love</h1>
            <p className="mb-5 ">Flow with me into the morning Tuesdays and Sundays at Mind Body Love
            </p>
            <button>
                <Link
                    to="https://www.eventbrite.com/e/morning-vinyasa-flow-in-balboa-park-nature-flow-tickets-1375070566079?aff=oddtdtcreator"
                    className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
                >
                    See Schedule
                </Link>
            </button>
        </div> */}
    </div>

    <div className="md:w-2/3 m-5 flex justify-center">
        <img
            src={require("./images/nature_flow.png")}
            alt="Yoga in Golden Gate Park"
            className="md:w-full lg:w-2/3 object-cover"
        />
    </div>
</div>

<div className="h-auto items-center justify-center md:hidden">
    <div className="md:w-2/3 m-5 flex justify-center">
        <img
            src={require("./images/nature_flow.png")}
            alt="Yoga in Golden Gate Park"
            className="md:w-full lg:w-2/3 object-cover"
        />
    </div>
    <div className=" m-5 flex flex-col">
        <div className=" mb-10">
            <h1 className="text-4xl mb-2 ">Nature Flow - San Diego</h1>
            <p className="mb-5 ">Unroll your mat and connect with the earth. Every Sunday at 10 AM we come together to move and breathe,
                finding harmony with our natural surroundings.
                All experience levels are welcome.
            </p>
            <p className="font-bold">📍 Balboa Park - Upas Street & 7th Avenue</p>
            <p className="mb-5 font-bold">Sundays, 10AM</p>
            <button
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
      >
        <Link to="https://sinainfluxyoga.setmore.com/classes/ea9e0268-6e6c-402a-93b4-964b6324c365">Sign Up Here</Link>

      </button>
        </div>
    </div>


</div>

</div>

        </>
    )
}
